define('modules/shell/widgets/datepicker/i18n/de',{
    "datepicker":{
        "clear":"Klar"
    }
});

